export default {
  "main-container": "_main-container_y6zj4n",
  "content-container": "_content-container_y6zj4n",
  "footer": "_footer_y6zj4n",
  "icon": "_icon_y6zj4n"
};
